import { createReducer } from './utils.js';
import {
  GET_RESPUESTAS_REQUEST,
  GET_RESPUESTAS_SUCCESS,
  GET_RESPUESTAS_FAILURE,
  SNACK_SET,
} from './constants.js';

const defaultState = {
  loading: false,
  errorMessage: null,
  respuestas: [],
};

export const reducer = createReducer(defaultState, {
  [GET_RESPUESTAS_REQUEST]: handleGetRespuestasRequest,
  [GET_RESPUESTAS_SUCCESS]: handleGetRespuestasSuccess,
  [GET_RESPUESTAS_FAILURE]: handleGetRespuestasFailure,
});

function handleGetRespuestasRequest(state) {
  return {
    ...state,
    respuestas: [],
    loading: true,
  };
}

function handleGetRespuestasSuccess(state, { payload: { respuestas } }) {
  return {
    ...state,
    respuestas,
    loading: false,
    errorMessage: null,
  };
}

function handleGetRespuestasFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}

export function getRespuestas(tenant_id, sucursal_id) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: GET_RESPUESTAS_REQUEST });
    try {
      const respuestas = await dataSource.getRespuestas(tenant_id, sucursal_id);
      dispatch({ type: GET_RESPUESTAS_SUCCESS, payload: { respuestas } });
    } catch (error) {
      dispatch({ type: GET_RESPUESTAS_FAILURE, payload: { error } });
      const snack = {
        open: true,
        message: 'Error al obtener las respuestas' + error.message,
        severity: 'error',
      };
      dispatch({
        type: SNACK_SET,
        payload: { snack },
      });
    }
  };
}
